const reviews = [
  {
    quote:
      "I expected another motivation book. What I got was a 30-day surgical strike on my excuses. Day 14 broke me. Day 30 rebuilt me.",
    name: "Marcus J.",
    role: "Founder, Lagos",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&w=160&q=80",
  },
  {
    quote:
      "Kendrick doesn't write to comfort you. He writes to convict you. The 3x standard reframed how I run my mornings.",
    name: "Priya R.",
    role: "Product lead",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=160&q=80",
  },
  {
    quote:
      "Read it. Highlighted it. Argued with it. Then ran the system. My income is up, my sleep is real, my circle is sharper.",
    name: "Devon K.",
    role: "Consultant, NYC",
    avatar:
      "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&w=160&q=80",
  },
  {
    quote:
      "The cleanest, hardest-hitting growth playbook I've read in years. Zero fluff. Surgical.",
    name: "Aisha M.",
    role: "Athlete & speaker",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&w=160&q=80",
  },
  {
    quote:
      "The Physical week alone justified the price. I rebuilt my evening routine in seven days.",
    name: "Tomás L.",
    role: "Engineer",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=160&q=80",
  },
];

const Card = ({ r }) => (
  <div className="shrink-0 w-[360px] md:w-[420px] mx-3 p-7 rounded-2xl bg-[#121212] border border-white/5">
    <p className="font-serif-display text-lg text-neutral-100 leading-snug">
      &ldquo;{r.quote}&rdquo;
    </p>
    <div className="mt-6 flex items-center gap-3">
      <img
        src={r.avatar}
        alt=""
        className="w-10 h-10 rounded-full object-cover border border-[#d4af37]/30"
      />
      <div>
        <div className="text-sm text-white">{r.name}</div>
        <div className="text-xs text-neutral-500">{r.role}</div>
      </div>
    </div>
  </div>
);

export default function Testimonials() {
  const loop = [...reviews, ...reviews];

  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12">
        <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37]/80">
          What readers say
        </p>
        <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-white leading-[1.05] tracking-tight max-w-3xl">
          Not reviews. <em className="gold-text">Receipts.</em>
        </h2>
      </div>

      <div className="relative">
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10" />

        <div className="flex marquee-track w-max">
          {loop.map((r, i) => (
            <Card key={i} r={r} />
          ))}
        </div>
      </div>
    </section>
  );
}
